// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f775b03a","885":"7601b16a"}[chunkId] + ".chunk.js";
};